declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ctm: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    opera: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Trustpilot: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _qevents: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _fs_namespace: {
      getCurrentSessionURL?: (arg: boolean) => string
    }
  }
}

export enum PaymentPlan {
  MONTHLY = 'monthly',
  ANNUAL = 'annual',
}

export enum Channel {
  WEB = 'WEB',
  COMPARE_THE_MARKET = 'COMPARE_THE_MARKET',
  GO_COMPARE = 'GO_COMPARE',
  CONFUSED = 'CONFUSED',
  QUOTEZONE = 'QUOTEZONE',
  MONEY_SUPERMARKET = 'MONEY_SUPERMARKET',
  USWITCH = 'USWITCH',
}

export interface LicenceInfo {
  country: string
  UKlicenceDurationString: string
}

export enum Segment {
  STUDENTS = 'students',
}

//TODO: this should comes from S'mores and be aligned with BE
// BE returns a pair of name/value
// S'mores uses a pair of label/value

export interface ListItemBEResponse {
  name: string
  value: string
  tags?: string[]
}

export interface ImpactSegmentContext {
  context: {
    referrer: {
      type: string
      id: string
    }
  }
}

export interface OptionItem<T extends string | number | boolean = string> {
  label: string
  value: T
}

export interface RadioOptionItem extends OptionItem {
  bodyCopy?: string
}

type Day = number
type Month = number
type Year = number
export type IsoDateFormat = `${Year}-${Month}-${Day}`

export type MonthYearDateObject = {
  // TODO: 60 days after release of owner/keeper we can remove the null on month
  month: string
  year: string
}

export type FeatureFlagsResponse = Record<
  string,
  { group: null; expiresInSeconds: number; active: boolean }
>

/*
 * The test group is the group that the participant is in.
 * By default, the test groups are CONTROL and VARIANT
 */
export type TestGroup = 'VARIANT' | 'CONTROL'

export type Participant = {
  testName: string
  testGroup: TestGroup
  testVersion: number
  version: number
  excludedFromTestAnalysis: boolean
}

export type AbTestParams = {
  userKey: string
  participantId: string
  tests: string[]
}

// Tied directly to Subscription Groups within Braze and uk-multi-customer-matching
export enum SubscriptionGroupNames {
  PRODUCT_UPDATES = 'Product Updates',
  MARKETING = 'Marketing',
}
